import React from 'react'

export default function DownSideArrowIco() {
  return (
    <svg
      width="8"
      height="4"
      viewBox="0 0 8 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.672647 0.167938C0.787744 0.0559791 0.93423 -2.86999e-07 1.11211 -2.79224e-07C1.28999 -2.71448e-07 1.43647 0.0559791 1.55157 0.167938L4 2.54962L6.44843 0.167939C6.56353 0.0559794 6.71002 -3.45313e-08 6.88789 -2.67561e-08C7.06577 -1.89808e-08 7.21226 0.0559794 7.32735 0.167939C7.44245 0.279898 7.5 0.422392 7.5 0.595419C7.5 0.768447 7.44245 0.910942 7.32735 1.0229L4.43946 3.83206C4.37668 3.89313 4.30867 3.93649 4.23543 3.96214C4.16218 3.98738 4.08371 4 4 4C3.91629 4 3.83782 3.98738 3.76457 3.96214C3.69133 3.93649 3.62332 3.89313 3.56054 3.83206L0.672646 1.0229C0.557549 0.910941 0.5 0.768447 0.5 0.595419C0.5 0.422391 0.557549 0.279898 0.672647 0.167938Z"
        fill="black"
      />
    </svg>
  )
}
